import React from 'react';
import WarningSign from '../../SVG/WarningSign';

const PaymentRenderer = (props) => {
  const determinePaymentMessage = () => {
    if (!props.existingClient) {
      return 'החיוב ירד מאמצעי תשלום:';
    } else {
      if (props.paymentMethod) {
        if (props.paymentMethod == 'CC' || props.ccUpdated) {
          return 'החיוב ירד מאמצעי תשלום:';
        } else {
          if (props.paymentMethod == 'Bank') {
            return 'החיוב ירד בהוראת קבע מחשבון:';
          } else return null;
        }
      } else return null;
    }
  };

  const determinePaymentData = () => {
    if (!props.existingClient) {
      return '**** **** **** ' + props.Credit4Digits?.replace(/x/g, '');
    } else {
      if (props.paymentMethod == 'CC' || props.ccUpdated) {
        return '**** **** **** ' + props.paymentData;
      } else {
        if (props.paymentMethod.toUpperCase() == 'BANK') return '*'.repeat(props.paymentData.length - 4) + props.paymentData.slice(-4);
        else return props.paymentData;
      }
    }
  };

  const payMessage = determinePaymentMessage();
  if (payMessage) {
    if (!props.shouldUpdate || props.ccUpdated) {
      return (
        <div className='bottom-where-flight-to-shadowtext' style={{marginBottom: '8px'}}>
          <div>{payMessage}</div>
          <div style={{display: 'flex'}}>
            <span className='bold mx-1' style={{direction: 'ltr'}}>
              {determinePaymentData()}
            </span>
            <div className='bottom-pink-text-click' onClick={props.onclick}>
              עדכון
            </div>
          </div>
        </div>
      );
    } else {
      //todo - return error that he should update
      return (
        <div className='bottom-where-flight-to-shadowtext'>
          <div>{payMessage}</div>
          <div style={{display: 'flex'}}>
            <span className='bold mx-1' style={{direction: 'ltr'}}>
              {determinePaymentData()}
            </span>
          </div>
          <div className='paymentWarningContainer'>
            <WarningSign />
            <p>
              ישנה בעיה עם כרטיס האשראי
              <br />
              על מנת להמשיך יש ל
              <span className='bottom-pink-text-click' onClick={props.onclick}>
                עדכן כרטיס חדש
              </span>
            </p>
          </div>
          {props.showErrorMessage && (
            <div className='bottom-error-message pink' style={{marginRight: 0}}>
              עליכם לעדכן אמצעי תשלום כדי להתקדם
            </div>
          )}
        </div>
      );
    }
  } else {
    //todo - return error that he must update
    return (
      <div className='bottom-where-flight-to-shadowtext'>
        <div className='paymentWarningContainer'>
          <WarningSign />
          <p>
            כרטיס האשראי לא קיים במערכת
            <br />
            כדי להמשיך צריך ל
            <span className='bottom-pink-text-click' onClick={props.onclick}>
              עדכן כרטיס חדש
            </span>
          </p>
        </div>
        {props.showErrorMessage && (
          <div className='bottom-error-message pink' style={{marginRight: 0}}>
            עליכם לעדכן אמצעי תשלום כדי להתקדם
          </div>
        )}
      </div>
    );
  }
};

export default PaymentRenderer;
